import React, { useState, useEffect } from 'react';
import { Box, Collapse, Typography } from '@mui/material';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const PreflightSection = ({ missionData, setMissionData, setIsDirty, handleFieldChange }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    useEffect(() => {
        setIsExpanded(!missionData?.completedAt);
    }, [missionData]);

    return (
        <Box
            sx={{
                backgroundColor: '#ffffff',
                border: '1px solid #dcdcdc',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
            }}
        >
            {/* Section Header */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    marginBottom: isExpanded ? '16px' : '0px',
                }}
                onClick={() => setIsExpanded(!isExpanded)}
            >
                <FlightTakeoffIcon sx={{ color: '#42a5f5', marginRight: '8px' }} />
                <Typography variant="h6" sx={{ flexGrow: 1 }}>
                    Pre-flight Checklist
                </Typography>
                {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </Box>

            {/* Expandable Content */}
            <Collapse in={isExpanded}>
                <Typography variant="body2" sx={{ color: '#6c757d', paddingLeft: '32px' }}>
                    Pre-flight checklist details go here.
                </Typography>
            </Collapse>
        </Box>
    );
};

export default PreflightSection;